import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StockCountSandbox } from 'app/core/sandboxes/stock-count.sandbox';
import { Definition } from 'app/core/store/definitions/definition.interface';
import { Definitions } from 'app/core/store/definitions/definitions.interface';
import { StockCountCreateOrder } from 'app/core/store/stock-count/stock-count.interface';

@Component({
  selector: 'stock-count-list-orders',
  templateUrl: './stock-count-create-multi-select.component.html',
  styleUrls: ['../../../florders/florder-list/florder-list.scss', './stock-count-create-multi-select.component.scss'],
})
export class StockCountListOrdersComponent implements OnChanges {
  selectedOrders: string[] = [];
  selectedAll: boolean;
  sandbox: StockCountSandbox;

  selectedOrderList: StockCountCreateOrder[];

  @Input() orders: StockCountCreateOrder[] = null;
  @Input() shipTos: Definition[];
  @Input() definitions: Definitions;

  @Output() goToCounts: EventEmitter<{
    selectedOrders: StockCountCreateOrder[];
  }> = new EventEmitter();

  constructor(sandbox: StockCountSandbox, private translateService: TranslateService) {
    this.sandbox = sandbox;
  }

  columns = [
    {
      id: 'etmOrderNo',
      colName: this.translateService.instant('STOCK_COUNT.LABELS.ORDER'),
    },
    {
      id: 'salesOrderNo',
      colName: this.translateService.instant('STOCK_COUNT.LABELS.SALESORDER'),
    },
    {
      id: 'from',
      colName: this.translateService.instant('STOCK_COUNT.LABELS.FROM'),
    },
    {
      id: 'to',
      colName: this.translateService.instant('STOCK_COUNT.LABELS.TO'),
    },
    {
      id: 'customerRefNo',
      colName: this.translateService.instant('STOCK_COUNT.LABELS.CUSTOMER'),
    },
    {
      id: 'requestedDeliveryDate',
      colName: this.translateService.instant('STOCK_COUNT.LABELS.REQUESTEDDATE'),
    },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.orders) {
      this.selectedOrderList = [...this.orders];
    }
  }

  shallowEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (object1[key] !== object2[key]) {
        return false;
      }
    }

    return true;
  }

  checkboxChanged(change: { checked: boolean; order: StockCountCreateOrder }) {
    // find correct order
    const indexChangedOrder = this.orders.findIndex(o => {
      if (this.shallowEqual(o, change.order)) {
        return true;
      }
    });

    this.selectedOrderList[indexChangedOrder] = {
      ...this.selectedOrderList[indexChangedOrder],
      includedInCount: change.checked,
    };
  }

  toggleSelectAll(value) {
    this.selectedAll = value.checked;
    if (value.checked) {
      this.selectedOrders = this.orders.map(order => order.etmOrderNo);
    } else {
      this.selectedOrders = [];
    }
  }

  countBtnClicked() {
    this.goToCounts.emit({
      selectedOrders: this.selectedOrderList,
    });
  }

  cancelClicked() {
    this.sandbox.cancelCreate();
  }
}
